import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=16df3c06&scoped=true&"
import script from "./SplitButton.vue?vue&type=script&lang=js&"
export * from "./SplitButton.vue?vue&type=script&lang=js&"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=16df3c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df3c06",
  null
  
)

export default component.exports